import {
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS,
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_BY_DRAFT_SUCCESS,
} from '@app/store/actionTypes';
import {
  changeContractSetupSigningProgressType,
  ContractSetupAction,
} from '@app/store/contract-setup/actions';
import SigningProgressType from '@app/store/SigningProgressType';

function calculateSigningProgressType<T>(
  participants: T[],
  signingOrderSelector: (participant: T) => number
): SigningProgressType {
  return participants.every((participant) => signingOrderSelector(participant) === 1)
    ? 'outOfOrder'
    : 'inOrder';
}

type ContractSetupSigningProgressTypeStateType = SigningProgressType;

const initialState: ContractSetupSigningProgressTypeStateType = 'inOrder';

export default function reducer(
  state: ContractSetupSigningProgressTypeStateType = initialState,
  action: ContractSetupAction
) {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
    case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST:
      return initialState;
    case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS:
      return calculateSigningProgressType(
        action.payload.participants,
        (participant) => participant.signingOrder
      );
    case CONTRACT_SETUP_BY_DRAFT_SUCCESS:
      return calculateSigningProgressType(
        action.payload.participants,
        (participant) => participant.signingOrder
      );
    case changeContractSetupSigningProgressType.type:
      return action.payload;
    default:
      return state;
  }
}
